export default __webpack_public_path__ + "static/media/icon_drills_azure.9f630b72.png";